
<body
    style="background-image: url('./assets/media/bg/MicrosoftTeams-image.png');">
    <div class="kikimg">
        <a href="#" class="flex-column-auto mt-5">
            <img src="./assets/media/logos/kikblox.png" class="max-h-70px" style="position: absolute;"/>
        </a>
    </div>
    <div class="container">
        <div class="terms-form">
            <button type="button" class="close" aria-label="Close" style="font-size: 30px;"  routerLink="/auth/register" >
                <span aria-hidden="true">&times;</span>
              </button>
            <h1>Terms & Conditions</h1>
            <div class="typewriter">
                <p id="eula-text">
                    <!-- Your terms and conditions content here -->
                </p>
            </div>
            <button  routerLink="/auth/register"  mat-raised-button color="primary">Back</button>

        </div>
    </div>
</body>
